<div class="page-print">
	@if (isDemo) {
	<div class="watermark">
		<p>{{ labels().WATERMARK_DEMO }}</p>
	</div>
	}
	<div class="menu-print">
		<div class="voice-menu">
			<span><strong>{{ labels().PRINT_BOM_PATIENT_ID }}</strong> {{currentCase?.patient?.number}}</span>
			<span><strong>{{ labels().PRINT_BOM_PLAN_ID }}</strong> {{currentCase?.number}}</span>
			<span><strong>{{ labels().PRINT_BOM_PLAN_SIDE }}</strong> {{currentCase?.side | anatomicalSideLabel}}</span>
			<span><strong>{{ labels().PRINT_BOM_PLAN_BONE_TYPE }}</strong> {{currentCase?.boneType | boneTypeLabel}}</span>
			<span style="font-size: 13pt"><strong> {{ labels().PRINT_BOM_MAIN_TITLE }} </strong></span>
			<span class="d-inline-block position-relative">
				<strong>{{ today | convertDate:false:true }}</strong>
				<span class="date-format date-format-subscript text-dark">{{ dateFormat }}</span>
			</span>
		</div>
		<span class="logo-text">{{ labels().APP_LOGO_TEXT }}</span>
	</div>

	@if (isJPSWarningVisible) {
	<div class="position-absolute text-center text-danger font-weight-bold" style="width: 1348px;">
		{{ labels().PRINT_BOM_JPS_WARNING }}
	</div>
	}

	<div class="wrapper-content">
		<div class="row">
			<div class="col-6">
				<list-material-table />
				<plat-instrument-consum-tables [isJPSExtension]="isJPS_Ext" />
				@if (isJPS_Ext) { <plat-instrument-drill-tables /> }
			</div>
			<div class="col-6">
				<plat-instrument-gen-table [isJPSExtension]="isJPS_Ext" />
				<plat-instrument-tray-tables />
			</div>
		</div>
		<div class="row justify-content-end">{{ labels().PRINT_BOTTOM_RIGHT_PAGE_TEXT }}</div>
	</div>
</div>